import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap } from 'rxjs/operators';
import { LoginService } from '../services/login.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);
    const tokenService = inject(LoginService);

    const token = tokenService.getToken();

    if (token) {
        // console.log('Using stored token:', token);
        const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
        return next(authReq);
    }

    return auth.getAccessTokenSilently().pipe(
        switchMap(newToken => {
            // console.log('Fetched new token:', newToken);
            tokenService.setToken(newToken); // Store new token
            localStorage.setItem('auth_token', JSON.stringify(newToken));

            const authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newToken}`),
            });

            return next(authReq);
        })
    );
};
